import { render, staticRenderFns } from "./Imb.vue?vue&type=template&id=cc1b1254&scoped=true&"
import script from "./Imb.vue?vue&type=script&lang=js&"
export * from "./Imb.vue?vue&type=script&lang=js&"
import style0 from "./Imb.vue?vue&type=style&index=0&id=cc1b1254&scoped=true&lang=css&"
import style1 from "./Imb.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc1b1254",
  null
  
)

export default component.exports